import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select"; // Import react-select
import FilteredMultiSelect from "./FilteredMultiSelect";
import { v4 as uuid } from "uuid";

// --- Helper Constants and Functions ---
const QUEST_DIFFICULTIES = [
  { key: "easy", label: "Let" },
  { key: "medium", label: "Mellem" },
  { key: "hard", label: "Svær" },
];

const REQUIREMENT_TYPES = [
  {
    value: "completeActivityWithChoice",
    label: "Fuldfør aktivitet med specifikt valg",
  },
  {
    value: "completeActivityOnce",
    label: "Fuldfør specifik aktivitet én gang",
  },
  { value: "earnPoints", label: "Optjen X point" },
  { value: "earnCO2", label: "Spar X kg CO2" },
  { value: "reachStreak", label: "Opnå X dages streak" },
  { value: "answerQuizCorrectly", label: "Besvar X quiz spørgsmål korrekt" },
];

const initialQuestLevelState = () => ({
  points: "",
  requirements: [],
});

const initialQuestsState = () => ({
  easy: initialQuestLevelState(),
  medium: initialQuestLevelState(),
  hard: initialQuestLevelState(),
});

const createNewRequirement = (type = REQUIREMENT_TYPES[0].value) => {
  let details = {};
  switch (type) {
    case "completeActivityWithChoice":
      details = {
        activityId: "",
        choiceText_da: "",
        choiceText_en: "",
        count: 1,
      };
      break;
    case "completeActivityOnce":
      details = { activityId: "" };
      break;
    case "earnPoints":
      details = { amount: "" };
      break;
    case "earnCO2":
      details = { amount: "" };
      break;
    case "reachStreak":
      details = { days: "" };
      break;
    case "answerQuizCorrectly":
      details = { count: 1 };
      break;
    default:
      break;
  }
  return {
    id: uuid(),
    description: "",
    description_en: "",
    type: type,
    details: details,
  };
};
// --- End Helper Constants and Functions ---

export default class ActivityPack extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      isEditMode: false,
      updatedActivityPack: {
        id: "",
        activities: [],
        packName: "",
        packTitle: "",
        packDescription: "",
        packTitle_en: "",
        packDescription_en: "",
        quests: initialQuestsState(),
      },
      activities: [],
      selectedActivities: [],
    };
  }

  componentDidMount() {
    this.setState({
      updatedActivityPack: {
        ...this.props.activityPack,
        quests: {
          easy: {
            ...(this.props.activityPack.quests?.easy ||
              initialQuestLevelState()),
            requirements:
              this.props.activityPack.quests?.easy?.requirements?.map((r) => ({
                ...r,
                id: r.id || uuid(),
              })) || [],
          },
          medium: {
            ...(this.props.activityPack.quests?.medium ||
              initialQuestLevelState()),
            requirements:
              this.props.activityPack.quests?.medium?.requirements?.map(
                (r) => ({ ...r, id: r.id || uuid() })
              ) || [],
          },
          hard: {
            ...(this.props.activityPack.quests?.hard ||
              initialQuestLevelState()),
            requirements:
              this.props.activityPack.quests?.hard?.requirements?.map((r) => ({
                ...r,
                id: r.id || uuid(),
              })) || [],
          },
        },
      },
      activities: this.props.activities || [],
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.activityPack !== prevProps.activityPack) {
      this.setState({
        updatedActivityPack: {
          ...this.props.activityPack,
          quests: {
            easy: {
              ...(this.props.activityPack.quests?.easy ||
                initialQuestLevelState()),
              requirements:
                this.props.activityPack.quests?.easy?.requirements?.map(
                  (r) => ({ ...r, id: r.id || uuid() })
                ) || [],
            },
            medium: {
              ...(this.props.activityPack.quests?.medium ||
                initialQuestLevelState()),
              requirements:
                this.props.activityPack.quests?.medium?.requirements?.map(
                  (r) => ({ ...r, id: r.id || uuid() })
                ) || [],
            },
            hard: {
              ...(this.props.activityPack.quests?.hard ||
                initialQuestLevelState()),
              requirements:
                this.props.activityPack.quests?.hard?.requirements?.map(
                  (r) => ({ ...r, id: r.id || uuid() })
                ) || [],
            },
          },
        },
        selectedActivities: this.state.isEditMode
          ? (this.props.activities || []).filter((activity) =>
              this.props.activityPack.activities?.includes(activity.id)
            )
          : this.state.selectedActivities,
      });
    }
    if (this.props.activities !== prevProps.activities) {
      this.setState({ activities: this.props.activities || [] });
    }
  }

  handleEditSave = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateActivityPack(
      this.state.updatedActivityPack,
      this.state.selectedActivities
    );
  };

  handleActivitySelectionChange = (selectedActivities) => {
    this.setState({ selectedActivities });
  };

  handleDeselectActivity(index) {
    var selectedActivities = [...this.state.selectedActivities];
    selectedActivities.splice(index, 1);
    this.setState({ selectedActivities });
  }

  handleActivityPackEdit = (event, activityPack) => {
    event.preventDefault();
    this.setState((prevState) => ({
      isEditMode: !prevState.isEditMode,
      selectedActivities: !prevState.isEditMode
        ? (this.props.activities || []).filter((activity) =>
            activityPack.activities?.includes(activity.id)
          )
        : [],
      updatedActivityPack: !prevState.isEditMode
        ? {
            ...activityPack,
            quests: {
              easy: {
                ...(activityPack.quests?.easy || initialQuestLevelState()),
                requirements:
                  activityPack.quests?.easy?.requirements?.map((r) => ({
                    ...r,
                    id: r.id || uuid(),
                  })) || [],
              },
              medium: {
                ...(activityPack.quests?.medium || initialQuestLevelState()),
                requirements:
                  activityPack.quests?.medium?.requirements?.map((r) => ({
                    ...r,
                    id: r.id || uuid(),
                  })) || [],
              },
              hard: {
                ...(activityPack.quests?.hard || initialQuestLevelState()),
                requirements:
                  activityPack.quests?.hard?.requirements?.map((r) => ({
                    ...r,
                    id: r.id || uuid(),
                  })) || [],
              },
            },
          }
        : prevState.updatedActivityPack,
    }));
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState((prevState) => ({
      updatedActivityPack: {
        ...prevState.updatedActivityPack,
        [name]: value,
      },
    }));
  }

  handleActivityPackCopy = (event) => {
    this.setState({ isEditMode: false });
    this.props.handleAddActivityPack(
      this.state.updatedActivityPack,
      event,
      true
    );
  };

  handleQuestPointsChange = (difficultyKey, points) => {
    this.setState((prevState) => ({
      updatedActivityPack: {
        ...prevState.updatedActivityPack,
        quests: {
          ...prevState.updatedActivityPack.quests,
          [difficultyKey]: {
            ...prevState.updatedActivityPack.quests[difficultyKey],
            points: points,
          },
        },
      },
    }));
  };

  handleAddQuestRequirement = (difficultyKey) => {
    const newReq = createNewRequirement();
    newReq.id = uuid();
    this.setState((prevState) => ({
      updatedActivityPack: {
        ...prevState.updatedActivityPack,
        quests: {
          ...prevState.updatedActivityPack.quests,
          [difficultyKey]: {
            ...prevState.updatedActivityPack.quests[difficultyKey],
            requirements: [
              ...(prevState.updatedActivityPack.quests[difficultyKey]
                .requirements || []),
              newReq,
            ],
          },
        },
      },
    }));
  };

  handleRemoveQuestRequirement = (difficultyKey, reqId) => {
    this.setState((prevState) => ({
      updatedActivityPack: {
        ...prevState.updatedActivityPack,
        quests: {
          ...prevState.updatedActivityPack.quests,
          [difficultyKey]: {
            ...prevState.updatedActivityPack.quests[difficultyKey],
            requirements: prevState.updatedActivityPack.quests[
              difficultyKey
            ].requirements.filter((req) => req.id !== reqId),
          },
        },
      },
    }));
  };

  handleQuestRequirementChange = (difficultyKey, reqId, field, value) => {
    this.setState((prevState) => ({
      updatedActivityPack: {
        ...prevState.updatedActivityPack,
        quests: {
          ...prevState.updatedActivityPack.quests,
          [difficultyKey]: {
            ...prevState.updatedActivityPack.quests[difficultyKey],
            requirements: prevState.updatedActivityPack.quests[
              difficultyKey
            ].requirements.map((req) =>
              req.id === reqId
                ? {
                    ...req,
                    [field]: value,
                    ...(field === "type"
                      ? { details: createNewRequirement(value).details }
                      : {}),
                  }
                : req
            ),
          },
        },
      },
    }));
  };

  handleQuestRequirementDetailChange = (
    difficultyKey,
    reqId,
    detailField,
    value
  ) => {
    this.setState((prevState) => ({
      updatedActivityPack: {
        ...prevState.updatedActivityPack,
        quests: {
          ...prevState.updatedActivityPack.quests,
          [difficultyKey]: {
            ...prevState.updatedActivityPack.quests[difficultyKey],
            requirements: prevState.updatedActivityPack.quests[
              difficultyKey
            ].requirements.map((req) =>
              req.id === reqId
                ? { ...req, details: { ...req.details, [detailField]: value } }
                : req
            ),
          },
        },
      },
    }));
  };

  renderQuestRequirementFields = (difficultyKey, req) => {
    const allActivitiesForSelection = this.state.activities || [];
    const selectedActivityForChoices = allActivitiesForSelection.find(
      (act) => act.id === req.details.activityId
    );

    const activityOptions = this.state.selectedActivities.map((act) => ({
      value: act.id,
      label: `${act.activityName} (${act.activityType || "Uden type"})`,
    }));

    const selectedActivityOption = activityOptions.find(
      (opt) => opt.value === req.details.activityId
    );

    let choiceOptionsForSelect = [];
    if (
      selectedActivityForChoices &&
      selectedActivityForChoices.choices &&
      selectedActivityForChoices.choices.length > 0
    ) {
      choiceOptionsForSelect = selectedActivityForChoices.choices.map(
        (choice, index) => ({
          // Store both da and en text, or prioritize da if available
          value: JSON.stringify({
            text_da: choice.text_da,
            text_en: choice.text_en,
          }), // Store both texts as a stringified object
          label: choice.text_da || choice.text_en || `Valg ${index + 1}`, // Display text
        })
      );
    }
    // Find the currently selected choice option for the react-select component
    const currentSelectedChoiceOption = choiceOptionsForSelect.find((opt) => {
      try {
        const optValue = JSON.parse(opt.value);
        return (
          optValue.text_da === req.details.choiceText_da &&
          optValue.text_en === req.details.choiceText_en
        );
      } catch (e) {
        return false;
      }
    });

    return (
      <div key={req.id} className="box" style={{ marginBottom: "1em" }}>
        <div className="field">
          <label className="label is-small">Krav Beskrivelse (Dansk)</label>
          <div className="control">
            <input
              className="input is-small"
              type="text"
              value={req.description}
              onChange={(e) =>
                this.handleQuestRequirementChange(
                  difficultyKey,
                  req.id,
                  "description",
                  e.target.value
                )
              }
            />
          </div>
        </div>
        <div className="field">
          <label className="label is-small">Krav Beskrivelse (Engelsk)</label>
          <div className="control">
            <input
              className="input is-small"
              type="text"
              value={req.description_en}
              onChange={(e) =>
                this.handleQuestRequirementChange(
                  difficultyKey,
                  req.id,
                  "description_en",
                  e.target.value
                )
              }
            />
          </div>
        </div>
        <div className="field">
          <label className="label is-small">Krav Type</label>
          <div className="control">
            <div className="select is-small">
              <select
                value={req.type}
                onChange={(e) =>
                  this.handleQuestRequirementChange(
                    difficultyKey,
                    req.id,
                    "type",
                    e.target.value
                  )
                }
              >
                {REQUIREMENT_TYPES.map((rt) => (
                  <option key={rt.value} value={rt.value}>
                    {rt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {req.type === "completeActivityWithChoice" && (
          <>
            <div className="field">
              <label className="label is-small">Aktivitet</label>
              <div className="control">
                <Select
                  options={activityOptions}
                  value={selectedActivityOption}
                  onChange={(selectedOption) =>
                    this.handleQuestRequirementDetailChange(
                      difficultyKey,
                      req.id,
                      "activityId",
                      selectedOption ? selectedOption.value : ""
                    )
                  }
                  placeholder="Vælg eller søg aktivitet..."
                  isClearable
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            {selectedActivityForChoices &&
              selectedActivityForChoices.choices &&
              selectedActivityForChoices.choices.length > 0 && (
                <div className="field">
                  <label className="label is-small">Valgmulighed (tekst)</label>
                  <div className="control">
                    <Select
                      options={choiceOptionsForSelect}
                      value={currentSelectedChoiceOption}
                      onChange={(selectedChoiceOpt) => {
                        if (selectedChoiceOpt) {
                          try {
                            const choiceTexts = JSON.parse(
                              selectedChoiceOpt.value
                            );
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_da",
                              choiceTexts.text_da || ""
                            );
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_en",
                              choiceTexts.text_en || ""
                            );
                          } catch (e) {
                            console.error("Error parsing choice text:", e);
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_da",
                              ""
                            );
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_en",
                              ""
                            );
                          }
                        } else {
                          this.handleQuestRequirementDetailChange(
                            difficultyKey,
                            req.id,
                            "choiceText_da",
                            ""
                          );
                          this.handleQuestRequirementDetailChange(
                            difficultyKey,
                            req.id,
                            "choiceText_en",
                            ""
                          );
                        }
                      }}
                      placeholder="Vælg påkrævet valgmulighed..."
                      isClearable
                      classNamePrefix="react-select-choice"
                    />
                  </div>
                </div>
              )}
            <div className="field">
              <label className="label is-small">Antal gange</label>
              <div className="control">
                <input
                  className="input is-small"
                  type="number"
                  min="1"
                  value={req.details.count || 1}
                  onChange={(e) =>
                    this.handleQuestRequirementDetailChange(
                      difficultyKey,
                      req.id,
                      "count",
                      parseInt(e.target.value)
                    )
                  }
                />
              </div>
            </div>
          </>
        )}
        {req.type === "completeActivityOnce" && (
          <div className="field">
            <label className="label is-small">Aktivitet</label>
            <div className="control">
              <Select
                options={activityOptions}
                value={selectedActivityOption}
                onChange={(selectedOption) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "activityId",
                    selectedOption ? selectedOption.value : ""
                  )
                }
                placeholder="Vælg eller søg aktivitet..."
                isClearable
                classNamePrefix="react-select"
              />
            </div>
          </div>
        )}
        {req.type === "earnPoints" && (
          <div className="field">
            <label className="label is-small">Point Antal</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                value={req.details.amount || ""}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "amount",
                    parseInt(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        {req.type === "earnCO2" && (
          <div className="field">
            <label className="label is-small">Kg CO2</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                step="0.1"
                value={req.details.amount || ""}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "amount",
                    parseFloat(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        {req.type === "reachStreak" && (
          <div className="field">
            <label className="label is-small">Antal Dage Streak</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                min="1"
                value={req.details.days || ""}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "days",
                    parseInt(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        {req.type === "answerQuizCorrectly" && (
          <div className="field">
            <label className="label is-small">Antal Quiz Spørgsmål</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                min="1"
                value={req.details.count || 1}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "count",
                    parseInt(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        <button
          type="button"
          className="button is-danger is-small"
          onClick={() =>
            this.handleRemoveQuestRequirement(difficultyKey, req.id)
          }
        >
          Fjern Krav
        </button>
      </div>
    );
  };

  renderQuestDisplay = (difficultyKey, quest) => {
    if (!quest || !quest.requirements) return null;
    const allDisplayActivities = this.state.activities || [];

    return (
      <div
        key={difficultyKey}
        style={{
          marginBottom: "0.5rem",
          paddingLeft: "1rem",
          borderLeft: "2px solid #eee",
        }}
      >
        <p>
          <b>
            {QUEST_DIFFICULTIES.find((d) => d.key === difficultyKey)?.label}{" "}
            Quest Point:
          </b>{" "}
          {quest.points || "N/A"}
        </p>
        <b>Krav:</b>
        {quest.requirements.length === 0 ? (
          <p className="weak">(Ingen krav)</p>
        ) : (
          <ul>
            {quest.requirements.map((req) => {
              let detailsText = "";
              const activity = allDisplayActivities.find(
                (a) => a.id === req.details?.activityId
              );
              switch (req.type) {
                case "completeActivityWithChoice":
                  const choiceDisplayText =
                    req.details?.choiceText_da ||
                    req.details?.choiceText_en ||
                    "Ukendt Valg";
                  detailsText = `Aktivitet: ${
                    activity?.activityName || "Ukendt"
                  }, Valg: "${choiceDisplayText}", Antal: ${
                    req.details?.count || 1
                  }`;
                  break;
                case "completeActivityOnce":
                  detailsText = `Aktivitet: ${
                    activity?.activityName || "Ukendt"
                  }`;
                  break;
                case "earnPoints":
                  detailsText = `Optjen: ${req.details?.amount} point`;
                  break;
                case "earnCO2":
                  detailsText = `Spar: ${req.details?.amount} kg CO2`;
                  break;
                case "reachStreak":
                  detailsText = `Opnå: ${req.details?.days} dages streak`;
                  break;
                case "answerQuizCorrectly":
                  detailsText = `Besvar ${
                    req.details?.count || 1
                  } quiz spørgsmål korrekt`;
                  break;
                default:
                  break;
              }
              return (
                <li key={req.id || req.description}>
                  {req.description || req.description_en} ({req.type}):{" "}
                  {detailsText}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  };

  render() {
    const currentPack = this.state.isEditMode
      ? this.state.updatedActivityPack
      : this.props.activityPack;
    const currentQuests = currentPack.quests || initialQuestsState();

    return (
      <div className="tile is-near-half is-flex m-small box notification">
        <a
          href="/"
          onClick={(e) => {
            this.handleActivityPackEdit(e, this.props.activityPack);
          }}
          className="product-edit-icon"
        >
          <FontAwesomeIcon icon="edit" />
        </a>
        <button
          onClick={(event) =>
            this.props.handleDeleteActivityPack(
              this.props.activityPack.id,
              event
            )
          }
          className="delete"
        ></button>

        {this.state.isEditMode ? (
          <>
            <div className="column is-half">
              <p className="product-id">id: {this.props.activityPack.id}</p>
              <p>Navn</p>
              <input
                className="input is-medium"
                type="text"
                name="packName"
                value={this.state.updatedActivityPack.packName}
                onChange={this.handleInputChange}
              />
              <br />
              <p>Title (dansk)</p>
              <input
                className="input is-medium"
                type="text"
                name="packTitle"
                value={this.state.updatedActivityPack.packTitle}
                onChange={this.handleInputChange}
              />
              <br />
              <p>Title (engelsk)</p>
              <input
                className="input is-medium"
                type="text"
                name="packTitle_en"
                value={this.state.updatedActivityPack.packTitle_en}
                onChange={this.handleInputChange}
              />
              <br />
              <textarea
                name="packDescription"
                className="textarea"
                placeholder="Beskrivelse (dansk)"
                value={this.state.updatedActivityPack.packDescription}
                onChange={this.handleInputChange}
              />
              <br />
              <textarea
                name="packDescription_en"
                className="textarea"
                placeholder="Beskrivelse (engelsk)"
                value={this.state.updatedActivityPack.packDescription_en}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="column is-half">
              <b>Vælg Aktiviteter (til pakken generelt)</b>
              <FilteredMultiSelect
                onChange={this.handleActivitySelectionChange}
                options={this.state.activities}
                selectedOptions={this.state.selectedActivities}
                textProp="activityName"
                valueProp="id"
                className="activity-selector"
                placeholder="søg"
                buttonText="vælg"
              />
              {this.state.selectedActivities.length === 0 && (
                <p>(intet valgt endnu)</p>
              )}
              {this.state.selectedActivities.length > 0 && (
                <ul>
                  {this.state.selectedActivities.map((activity, i) => (
                    <li key={activity.id}>
                      {`${activity.activityName} `}
                      <button
                        type="button"
                        onClick={() => this.handleDeselectActivity(i)}
                      >
                        ×
                      </button>
                    </li>
                  ))}
                </ul>
              )}

              <div className="box" style={{ marginTop: "1rem" }}>
                <h3 className="title is-5">Quests</h3>
                {QUEST_DIFFICULTIES.map((diff) => (
                  <div
                    key={diff.key}
                    className="box"
                    style={{
                      border: "1px solid #ddd",
                      padding: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    <h4 className="title is-6">{diff.label} Quest</h4>
                    <div className="field">
                      <label className="label">
                        Point for {diff.label} Quest
                      </label>
                      <div className="control">
                        <input
                          className="input"
                          type="number"
                          value={
                            this.state.updatedActivityPack.quests[diff.key]
                              ?.points || ""
                          }
                          onChange={(e) =>
                            this.handleQuestPointsChange(
                              diff.key,
                              e.target.value
                            )
                          }
                          placeholder={`Point for ${diff.label}`}
                        />
                      </div>
                    </div>
                    <h5 className="subtitle is-6">
                      Krav (
                      {
                        (
                          this.state.updatedActivityPack.quests[diff.key]
                            ?.requirements || []
                        ).length
                      }
                      )
                    </h5>
                    {(
                      this.state.updatedActivityPack.quests[diff.key]
                        ?.requirements || []
                    ).map((req) =>
                      this.renderQuestRequirementFields(diff.key, req)
                    )}
                    <button
                      type="button"
                      className="button is-link is-small"
                      onClick={() => this.handleAddQuestRequirement(diff.key)}
                    >
                      Tilføj Krav til {diff.label}
                    </button>
                  </div>
                ))}
              </div>
              <button
                type="submit"
                className="button is-info is-small mv-small"
                onClick={this.handleActivityPackCopy}
              >
                Opret kopi
              </button>
              <button
                type="button"
                className="button is-info is-small"
                onClick={this.handleEditSave}
              >
                Gem
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="column is-half">
              <p className="product-title">
                {this.props.activityPack.packName}
              </p>
              <p className="product-id">
                <b>id:</b> {this.props.activityPack.id}
              </p>
              <p className="product-id">
                <b>Title dansk:</b> {this.props.activityPack.packTitle}
                <br />
              </p>
              <p className="product-id">
                <b>Title engelsk:</b> {this.props.activityPack.packTitle_en}
                <br />
              </p>
              <p className="product-id">
                <b>Beskrivelse: </b>
                {this.props.activityPack.packDescription}
                <br />
              </p>
              <p className="product-id">
                <b>Beskrivelse (engelsk): </b>
                {this.props.activityPack.packDescription_en}
                <br />
              </p>
            </div>

            <div className="column is-half">
              <p className="product-id">
                <b>Aktiviteter:</b>
                <br />
              </p>
              {this.props.activityPack.activities &&
                this.props.activityPack.activities.map((activityId) => {
                  if (!activityId) {
                    return null;
                  }
                  const thisActivity = (this.state.activities || []).find(
                    (a) => {
                      return a.id === activityId;
                    }
                  );
                  return (
                    <div key={activityId} className="product-id">
                      {thisActivity?.activityName}
                      <br />
                      <p className="weak"> {thisActivity?.category}</p>
                      <p className="weak">id: {thisActivity?.id}</p>
                    </div>
                  );
                })}

              <div style={{ marginTop: "1rem" }}>
                <p className="product-id">
                  <b>Quests:</b>
                </p>
                {QUEST_DIFFICULTIES.map((diff) =>
                  this.renderQuestDisplay(diff.key, currentQuests[diff.key])
                )}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
